/**
 * AAA IDP Form - Your Details
 * 
 */
import * as React from 'react';
import AutoClub from '../../../components/auto-club/AutoClub';
import Name from '../../../components/name/Name';
import ContactNumber from '../../../components/contact-number/ContactNumber';
import DateOfBirth from '../../../components/date-of-birth/DateOfBirth';
import DateOfTravel from '../../../components/date-of-travel/DateOfTravel';
import ConfirmEmail from '../../../components/confirm-email/ConfirmEmail';
import Email from '../../../components/email/Email';
import PlaceOfBirth from '../../../components/place-of-birth/PlaceOfBirth';
import PhotoUpload from '../../../components/photo-upload/PhotoUpload';
import PhotoGuidelines from '../../../components/photo-guidelines/PhotoGuidelines';
import Info from '../../../components/info/Info';
import './PersonalDetails.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class PersonalDetails extends React.Component {
  render() {
    const {
      bugsnagClient
    } = this.props;
    return /*#__PURE__*/_jsxs("section", {
      id: "personal-details",
      children: [/*#__PURE__*/_jsxs("h2", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "Your details"
        }), /*#__PURE__*/_jsx("div", {
          children: "* Required"
        })]
      }), /*#__PURE__*/_jsx(DateOfTravel, {}), /*#__PURE__*/_jsx(Name, {}), /*#__PURE__*/_jsx(DateOfBirth, {}), /*#__PURE__*/_jsx(PlaceOfBirth, {}), /*#__PURE__*/_jsx(Email, {}), /*#__PURE__*/_jsx(ConfirmEmail, {}), /*#__PURE__*/_jsx(ContactNumber, {
        label: "contact number",
        name: "contactNumber",
        section: "personal-details"
      }), /*#__PURE__*/_jsx(AutoClub, {}), /*#__PURE__*/_jsx("h3", {
        className: "border",
        children: "Upload a recent photo"
      }), /*#__PURE__*/_jsx(PhotoGuidelines, {}), /*#__PURE__*/_jsxs("div", {
        className: "photo-uploads",
        children: [/*#__PURE__*/_jsx(PhotoUpload, {
          bugsnagClient: bugsnagClient,
          name: 'recentPhoto'
        }), /*#__PURE__*/_jsx("div", {
          className: "spacer"
        }), /*#__PURE__*/_jsx("div", {
          className: "spacer"
        }), /*#__PURE__*/_jsx(Info, {
          info: "Check that your photo clearly meets all the requirements listed above or your application may be rejected. We may use software which can adapt the photo to assist it to meet the photo requirements. This process has human involvement and is not wholly AI driven.",
          icon: "id-card"
        })]
      })]
    });
  }
}
export default PersonalDetails;